module.exports = __webpack_public_path__ + "img/editalEletronico.2c49f46e.jpg";